var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"weather ma-3 d-flex justify-center"},[_c('RainCloud'),_c('Landslide'),_c('Flood')],1),_c('v-card',{staticClass:"control ma-3"},[_c('Measurement'),_c('Print'),_c('Config')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }